// extracted by mini-css-extract-plugin
export default {"BrandContainer":"J2yUXuP1n88PwcamhK8n"};